import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Card } from '@mui/material';

function RaisingCardButton({ onClick, background, isSelected, children }) {
  const handleClick = () => {
    onClick && onClick();
  };

  return (
    <>
      {/* <Link to={href}> */}
      <Card
        onClick={handleClick}
        sx={{
          cursor: 'pointer',
          background: background || 'white',
          boxShadow: isSelected
            ? 'rgba(3, 102, 214, 0.3) 0px 0px 0px 3px'
            : undefined,
          '&:hover': {
            // opacity: 0.8,
            transition: 'all 0.5s ease',
            // boxShadow: '0 0 0 0.2rem rgba(0, 123, 255, 0.25)',
            boxShadow: 'rgba(3, 102, 214, 0.3) 0px 0px 0px 3px',
            transform: 'translate(0px, -3px)'
            // boxShadow: 'rgba(17, 12, 46, 0.15) 0px 4px 4px 0px',
            // filter: 'brightness(50%)',
            // '*': 'inherit',
          }
        }}

        //   onClick={() => onClick && onClick()}
      >
        {children}
      </Card>
      {/* </Link> */}
    </>
  );
}

RaisingCardButton.propTypes = {
  isSelected: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node
};

export default RaisingCardButton;
